import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {UNLOCK_ALL_STATUS} from './constants'
import rpcCall from '../../util/rpc/rpcCalls'
import $ from '../../alias/jquery'
import {getLockoutPolicyObject} from './selectors'

export const setUseLockoutPolicy = createAction(ActionTypes.USE_LOCKOUT_POLICY_SET)
export const setLockoutDuration = createAction(ActionTypes.LOCKOUT_DURATION_SET)
export const setLockoutThreshold = createAction(ActionTypes.LOCKOUT_THRESHOLD_SET)
export const setLockoutCounter = createAction(ActionTypes.LOCKOUT_COUNTER_SET)
export const setUnlockAllStatus = createAction(ActionTypes.LOCKOUT_UNLOCK_ALL_STATUS_SET)

export const resetAllLocks = () => (dispatch) => {
    dispatch(setUnlockAllStatus(UNLOCK_ALL_STATUS.IN_PROGRESS))
    rpcCall('SettingsService.resetAllLockouts', []).then(() => {
        dispatch(setUnlockAllStatus(UNLOCK_ALL_STATUS.SUCCESS))
    })
}

export const onPolicyChanged = () => (dispatch, getState) => {
    const lockoutPolicy = getLockoutPolicyObject(getState())
    $(document).trigger('lockoutPolicy_changed', [lockoutPolicy])
}



// WEBPACK FOOTER //
// ./web/js/administration/lockoutPolicy/actions.js